import type { Permission } from '@/vue/helpers/permissions'
import { useUserStore } from '../stores/userStore'

export default function useHasPermission(permission: Permission): boolean {
    return hasPermission(permission)
}

export function hasPermission(permission: Permission): boolean {
    return useUserStore().hasPermission(permission)
}
